import { render, staticRenderFns } from "./ServiceRow.vue?vue&type=template&id=78a21011&scoped=true&"
import script from "./ServiceRow.vue?vue&type=script&lang=js&"
export * from "./ServiceRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRow.vue?vue&type=style&index=0&id=78a21011&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a21011",
  null
  
)

export default component.exports